import React from "react";

const DotLoader = () => {
  return (
    <div className="dot-loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default DotLoader;
